import { AppIcon } from '@/shared/ui/icons'

type Props = {
  action: 'sign-in' | 'sign-up'
  onClick: () => void
}

export const AuthActionButton = ({ action, onClick }: Props) => {
  const isSignIn = action === 'sign-in'

  return (
    <p className="m-0 text-center text-sm font-semibold leading-none text-gray-700">
      {isSignIn ? 'Não faz parte ainda?' : 'Já possui conta?'}{' '}
      <button
        type="button"
        className="inline-flex cursor-pointer items-center gap-0.5 border-0 bg-transparent p-0 align-middle text-sm font-semibold leading-none text-brand"
        onClick={onClick}
      >
        {isSignIn ? 'Cadastre-se' : 'Entrar'}
        {/* Mesmo ícone das linhas de provedor: o caractere ">" tinha peso e
            alinhamento próprios, e destoava do resto da tela. */}
        <AppIcon name="arrow-right" size={14} aria-hidden />
      </button>
    </p>
  )
}
